import style from "./style.scss";
import { mergeClasses } from "../../../../../../components/helpers";

const VoltageRangeDisplay = ({ maxVolts, maxWatts }) => {
  const volts = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(typeof maxVolts === "number" && maxVolts >= 0 ? maxVolts : 0);

  return (
    <div class={style.voltageRange}>
      <div class={style.heading}>Set Charging Voltage</div>

      <div class={style.progressBar}>
        <span class={style.done}>1</span>
        <span class={style.done}>2</span>
        <span>3</span>
      </div>

      <div class={style.volts}>
        {volts}
        <span class={style.units}>V</span>
      </div>

      <div class={style.buttons}>
        <div class={style.select}>Select Model</div>
        <div class={style.custom}>Custom</div>
      </div>

      <div class={style.arrow} />
    </div>
  );
};

export default VoltageRangeDisplay;
